import Tpl from "./Tpl";
import {broadcastNeedBTContext, onBroadcastSendBTContext, onBroadcastWebviewshow, VideoBridgeInit} from "../../api";
import {_logSuccess} from "../../common/m_base/util";

export default class SubTpl extends Tpl {
    constructor(props) {
        super(props);
    }

    async init({JsBridgeRes}) {
        super.init({JsBridgeRes});

        this.enableDebugMode()

        let SDKContext = await this.initSDKContext()

        let subTplId = this.selfViewInstanceId

        // 子模板通过监听 broadcastwebviewshow 来确认自己是否已经被展示
        onBroadcastWebviewshow({
            cb: res => {
                this.show(res)
            }
        })

        // 子模板需要向大模板索取 "根视图和大模板视图 ID"
        console.log('子模板需要向大模板索取 "根视图和大模板视图 ID"')
        onBroadcastSendBTContext({
            cb: res => {
                _logSuccess(`子模板${subTplId}收到大模板发来的上下文信息`, res)
                window.MTG_SDKContext = res.param.data.MTG_SDKContext
            }
        })
        await broadcastNeedBTContext({unitId: this.unitId, data: {subTplId}})

        return SDKContext
    }

    show(res) {
        super.show(res);
    }

}